import { Link } from "react-router-dom";
import {useState, useEffect} from 'react';

function Contact(props) {

    const [formData, setFormData] = useState({ name: '', emailAddress: '', subject: '', message: '' });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };

      const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Data needs to be sent as URL parameters for the simple doPost function above
            const params = new URLSearchParams(formData).toString();
            const response = await fetch(`${scriptUrl}?${params}`, {
              method: 'POST',
              mode: 'no-cors' // Bypasses the CORS restriction
            });
            
            // Even if successful, 'no-cors' mode means response.ok will be false. 
            // The script will run in the background.
            console.log('Form submitted (cannot confirm success due to no-cors mode)');
            alert('Form submitted successfully!'); // Show a success message to the user
            setFormData({ name: '', emailAddress: '', subject: '', message: '' });
            
          } catch (error) {
            console.error('Error:', error.message);
            alert('Form submission failed!');
          }
            
      };

     

      const scriptUrl = 'https://script.google.com/macros/s/AKfycbx4WoMFFYa3lCXcxkWe-unLvaYXh1_otPbJlyOg9YTxXyHvitz3MW3gHEtvysS6jR1G/exec';

    return (
        <div ref={props.contactRef} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '210px',
            paddingTop: '20px'
        }}>
            <h1 className='title' style={{color: '#414243'}}>contact</h1>

            <form method="POST" action={scriptUrl} onSubmit={handleSubmit} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                rowGap: '25px',
                width: '100%'
            }}>
                <input name='name' type="text" onChange={handleChange} placeholder="name"></input>
                <input name='emailAddress' type="email" onChange={handleChange} placeholder="email"></input>
                <input name='subject' type="text" onChange={handleChange} placeholder="subject"></input>
                <input name='message' type="text" onChange={handleChange} placeholder="message" style={{
                    height: '100px'
                }}></input>
                <button style={{
                    width: '10%',
                    height: '35px',
                    marginLeft: '0px'
                }}>Send</button>
            </form>
            <div style={{
                marginTop: '40%'
            }}>

            </div>
        </div>
    )
}

export default Contact;